import { observer } from 'mobx-react-lite'
import { Tabs, IconButton } from 'shared/ui'
import type { ITabItem } from 'shared/ui/Tabs/Tabs'
import type { AnalyticsChartPeriod, AnalyticsChartType } from 'entities/Analytics'
import type { ChartFilterStore } from 'pages/analytics/ui/ChartFilter/store/chartFilterStore'
import styles from './styles.module.scss'

interface IChartFilterProps {
  store: ChartFilterStore
}

const periodTabs: ITabItem<AnalyticsChartPeriod>[] = [
  { key: 'day', name: 'Day' },
  { key: 'week', name: 'Week' },
  { key: 'month', name: 'Month' },
  { key: 'year', name: 'Year' },
]

export const ChartFilter = observer(({ store }: IChartFilterProps) => {
  const { period, setPeriod, setChartType, chartType } = store
  const handlePeriodChange = (tab: ITabItem<AnalyticsChartPeriod>) => {
    setPeriod(tab.key)
  }

  const handleChartTypeToggle = () => {
    const newChartType: AnalyticsChartType = chartType === 'bar' ? 'line' : 'bar'
    setChartType(newChartType)
  }

  return (
    <div className={styles.container}>
      <IconButton
        icon={chartType === 'bar' ? 'lineChart' : 'barChart'}
        variant='contained'
        color='secondary'
        size='medium'
        onClick={handleChartTypeToggle}
        tooltipProps={{
          label: chartType === 'bar' ? 'Show as line' : 'Show as bar',
          placement: 'top',
        }}
        ariaLabel={chartType === 'bar' ? 'Show as line chart' : 'Show as bar chart'}
      />

      <Tabs
        variant='simpleWithoutBorder'
        tabs={periodTabs}
        activeTabKey={period}
        handleSelectTab={handlePeriodChange}
        gap={'4px'}
        tabsClassName={styles.tabs}
      />
    </div>
  )
})
